import AddEmployeeButton from "@/components/AddEmployeeButton.tsx";
import type { addEmployeeSchema } from "@/components/Forms/schema/saveEmployeeSchema.ts";
import MrtEmployeeTable from "@/components/Table/MrtEmployeeTable.tsx";
import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { Stack, Typography } from "@mui/material";
import { type ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";
import type { z } from "zod";

export type AddEmployeeFormValues = z.infer<typeof addEmployeeSchema>;

const AdminUserManagement = (): ReactNode => {
    const { hasPermission, hasAnyPermission } = useEmployee();

    useEffect(() => {
        document.title = "User Management";
    }, []);

    if (!hasAnyPermission(["create:employee", "delete:employee", "edit:employee"])) {
        return <div>You do not have access to this page.</div>;
    }

    return (
        <>
            <Stack
                sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography variant="h4" mb={2}>
                    Users
                </Typography>
                {hasPermission("create:employee") && <AddEmployeeButton />}
            </Stack>

            <MrtEmployeeTable />
            <Outlet />
        </>
    );
};

export default AdminUserManagement;
